export default __webpack_public_path__ + "static/media/Partnership_human_handshake.0511e8bf.svg";